import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageKey } from 'src/models/general/storage.key.enum';
import { SortValue } from 'src/models/general/sort.model';


interface SortService {
	storageKey: StorageKey;

	updateSort(pagination: SortValue): void;

	getSortObservable(): Observable<SortValue>;

	getCurrentSortValue(): SortValue;
}

@Injectable({
	providedIn: 'root'
})
export abstract class BaseSortService implements SortService {
	private sortSubject!: BehaviorSubject<SortValue>;
	private sort!: SortValue;
	storageKey!: StorageKey;

	getSortObservable(): Observable<SortValue> {
		if (!this.storageKey || !this.sortSubject) {
			throw Error(`Not initialized - no storageKey or sortSubject found. subclasses need to call 'init'`);
		}
		return this.sortSubject.asObservable();
	}

	updateSort(sort: SortValue): void {
		if (!this.storageKey) {
			throw Error(`No storageKey set - subclasses need to call 'init'`);
		}
		this.sort = sort;
		this.saveSortState();
		this.publishSortChanges();
	}

	getCurrentSortValue(): SortValue {
		return this.sort;
	}

	protected init(storageKey: StorageKey, sortDefaults: SortValue): void {
		if (!storageKey) {
			throw Error('StorageKey missing');
		}

		this.storageKey = storageKey;
		let initialValues = this.getSortFromStorage();
		if (!initialValues) {
			initialValues = sortDefaults;
		}
		this.sort = initialValues;
		this.sortSubject = new BehaviorSubject<SortValue>(initialValues);
	}

	private saveSortState(): void {
		localStorage.setItem(this.storageKey, JSON.stringify(this.sort));
	}

	private getSortFromStorage(): SortValue | null {
		const storedPagination = localStorage.getItem(this.storageKey);

		if (!storedPagination) {
			return null;
		}
		return JSON.parse(storedPagination);
	}

	private publishSortChanges(): void {
		this.sortSubject.next(this.sort);
	}

}


